<template>
  <div class="square-chart">
    <div class="title-square">
      <i class="icon-bg" :style="`background-color:` + color + `31;`">
        <feather :type="icon" size="18" :style="`color:` + color + `;`" />
      </i>
      <h4 class="chartSubtitle">
        {{ subtitle }}
      </h4>
      <h3 class="chartTitle">
        {{ title }}
      </h3>
    </div>
    <apexcharts
      class="chart-apex"
      :options="squareOption"
      :series="series"
      color="#2323"
      type="area"
    />
  </div>
</template>

<script>
import apexcharts from 'vue-apexcharts';

export default {
	components: {
		apexcharts,
	},
	// eslint-disable-next-line vue/require-prop-types
	props: ['series', 'squareChartOptions', 'icon', 'title', 'subtitle', 'color', 'cuntinterval'],
	data() {
		return {
			selected: null,
		};
	},
	computed: {
		selectedString() {
			return this.selected ? this.selected.toDateString() : '';
		},
		squareOption() {
			return {
				fill: {
					type: 'gradient',
					gradient: {
						shadeIntensity: 0.2,
						inverseColors: false,
						opacityFrom: 1,
						opacityTo: 0,
						stops: [0, 65, 100],
						colorStops: [
							{
								offset: 0,
								color: this.color,
								opacity: 0.4,
							},
							// {
							//   offset: 35,
							//   color: this.color,
							//   opacity: 0.3,
							// },
							{
								offset: 65,
								color: this.color,
								opacity: 0,
							},
							{
								offset: 100,
								color: this.color,
								opacity: 0,
							},
						],
					},
				},
				chart: {
					height: '140px',
					width: '100%',
					type: 'area',
					zoom: {
						enabled: false,
					},
					toolbar: {
						show: false,
					},
					lines: {
						show: false,
					},
				},
				dataLabels: {
					enabled: false,
				},
				stroke: {
					curve: 'smooth',
					width: 2.5,
					colors: [this.color],
				},
				xaxis: {
					labels: {
						show: false,
					},
					categories: this.cuntinterval,
					axisBorder: {
						show: false,
						color: '#fff',
						height: 5,
						width: '100%',
						offsetX: 0,
						offsetY: 0,
					},
				},
				yaxis: {
					labels: {
						show: false,
					},
				},
				legend: {
					show: false,
				},
				tooltip: {
					enabledOnSeries: false,
					shared: false,
					intersect: false,
					marker: {
						show: false,
					},
					x: {
						show: false,
					},
					z: {
						show: false,
					},
					legend: {
						show: false,
					},
				},
				grid: {
					show: true,
					borderColor: '#FFF',
					strokeDashArray: 0,
					position: 'back',
					xaxis: {
						lines: {
							show: false,
						},
					},
					yaxis: {
						lines: {
							show: false,
						},
					},
					row: {
						colors: undefined,
						opacity: 0,
					},
					column: {
						colors: undefined,
						opacity: 0,
					},
					padding: {
						top: 0,
						right: 0,
						bottom: 0,
						left: 0,
					},
				},
			};
		},
	},
};
</script>

<style scoped>
.feather-shopping-cart {
  color: #fb434f;
}
.icon-bg {
  width: 50px;
  height: 50px;
  /* margin-top: 10px; */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.square-chart {
  width: 100%;
  /* display: flex; */
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  border: 1px solid #deebfd;
  box-shadow: -8px 12px 18px 0 #dadee8;
}
.title-square {
  width: 100%;
  padding: 1rem 1rem 0 1rem;
}
.chartTitle {
  font-size: 15px;
  color: rgb(70 70 70 / 70%);
  margin-bottom: -35px;
}
.chartSubtitle {
  margin-top: 20px;
  font-size: 23px;
  font-weight: bold;
  color: #424242;
}
.chart-apex {
  display: flex;
  width: 100%;
  height: 100% !important;
  margin-left: -10px;
  margin-top:13px;
  /* width: 100%; */
}
</style>
